// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__O55yd","medium":"Tag_medium__s__4V"};